import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateVehicleDto } from '../../dtos/create-vehicle.dto';
import { UpdateVehicleDto } from '../../dtos/update-vehicle.dto';
import { createVehicleSchema } from '../schemas/create-vehicle.schema';
import { updateVehicleSchema } from '../schemas/update-vehicle.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateVehicleDto | UpdateVehicleDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateVehicleSchema if 'id' is present
		validationResult = updateVehicleSchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createVehicleSchema if 'id' is not present
		validationResult = createVehicleSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
